var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg408({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.37 88V176.34H151.3V207.89H132.37V231.03H95.56V207.89H23V176.34L94.51 88H132.37ZM95.56 134.48L61.7 176.34H95.56V134.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.962 157.28C441.362 161.262 446.268 166.169 449.682 172C453.237 177.689 455.015 184.231 455.015 191.627C455.015 201.156 452.171 209.547 446.482 216.8C440.935 224.053 433.042 229.671 422.802 233.653C412.704 237.493 401.113 239.413 388.028 239.413C374.944 239.413 363.282 237.493 353.042 233.653C342.944 229.671 335.051 224.053 329.362 216.8C323.815 209.547 321.042 201.156 321.042 191.627C321.042 184.231 322.748 177.689 326.162 172C329.717 166.169 334.695 161.262 341.095 157.28C331.282 149.458 326.375 139.644 326.375 127.84C326.375 118.88 328.935 111.058 334.055 104.373C339.317 97.6889 346.571 92.4978 355.815 88.8C365.202 85.1022 375.939 83.2533 388.028 83.2533C400.117 83.2533 410.784 85.1022 420.028 88.8C429.415 92.4978 436.668 97.6889 441.788 104.373C447.051 111.058 449.682 118.88 449.682 127.84C449.682 139.644 444.775 149.458 434.962 157.28ZM388.028 117.173C384.473 117.173 381.557 118.311 379.282 120.587C377.148 122.862 376.082 125.991 376.082 129.973C376.082 133.956 377.148 137.084 379.282 139.36C381.557 141.636 384.473 142.773 388.028 142.773C391.584 142.773 394.428 141.636 396.562 139.36C398.837 137.084 399.975 133.956 399.975 129.973C399.975 125.991 398.837 122.862 396.562 120.587C394.428 118.311 391.584 117.173 388.028 117.173ZM388.028 205.493C392.864 205.493 396.775 204.071 399.762 201.227C402.891 198.382 404.455 194.613 404.455 189.92C404.455 185.227 402.891 181.458 399.762 178.613C396.775 175.769 392.864 174.347 388.028 174.347C383.193 174.347 379.211 175.769 376.082 178.613C373.095 181.458 371.602 185.227 371.602 189.92C371.602 194.613 373.095 198.382 376.082 201.227C379.211 204.071 383.193 205.493 388.028 205.493Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 83,
    stroke: "#FF7B2E",
    strokeOpacity: 0.6,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 190.961H235.334V204.66H245.667V190.961Z",
    fill: "#FF7B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 180.687H235.333L225 114.45H256L245.667 180.687Z",
    fill: "#FF7B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg408);
export default __webpack_public_path__ + "static/media/img_408.81a44d52ab7e2f382f838a2cde8a9f6e.svg";
export { ForwardRef as ReactComponent };